import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { loginUser } from "../../actions/authAction";
import { closeModal, openModal } from "../../actions/modalAction";
import { Popup, Button, Form, Image } from "semantic-ui-react";
import CheckboxInput_2 from "../form/CheckboxInput_2";
import TextInput from "../form/TextInput";
//import SelectInput from "../form/SelectInput";
import { composeValidators, combineValidators, isRequired } from "revalidate";
import {
  isValidEmail,
  isValidPhone,
  isValidPassword,
} from "../validator/revalidator";
var passwordValidator = require("password-validator");

const validate = combineValidators({
  //************user */

  userIdRegister: composeValidators(
    isRequired("User Mobile as user ID"),
    isValidPhone({})
  )(),
  uemail: composeValidators(
    // isRequired("User Email"),
    isValidEmail({})
  )(),
  passwordRegister: composeValidators(
    isRequired("Password"),
    isValidPassword({})
  )(),
  uphone2: isValidPhone({}),
  uname: isRequired("User Name"),
  // password:isRequired('Password') ,
  password2: isRequired("Confirm Password"),

  userId: isRequired("UserId"),
  password: isRequired("Password"),
});

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(16) // Maximum length 16
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase() // Must have lowercase letters
  .has()
  .digits() // Must have digits
  .has()
  .symbols() // Must have symbols
  .has()
  .not()
  .spaces() // Should not have spaces
  .is()
  .not()
  .oneOf(["Password", "Password123"]); // Blacklist these values

class LoginRegisterForm extends Component {
  state = {
    showP: false,
    login: true,
    register: false,
    message: "",
  };

  // componentDidMount(){

  // }
  showLoginForm = () => {
    this.setState({ login: true, register: false });
  };
  showRegisterForm = () => {
    this.setState({ login: false, register: true });
  };
  onSubmit = (values) => {
    this.props.loginUser(values);
  };

  onSubmitRegister = async (values) => {
    //************
    try {
      const res = await axios.post("/api/user/create", { values });

      if (res.data.msg === "errorUserAlready") {
        this.setState({ message: "User Id Already Exists Use Another" });
      }

      if (res.data.msg === "success") {
        toastr.success("Registered Successfully");
        this.showLoginForm();
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log("error_register", error);
        toastr.error("Oops", "Something went wrong.Please Try Again_register");
      }
    }
    //**********
  };

  toggle = () => this.setState({ showP: !this.state.showP });
  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    const Reset = () => {
      reset();
      this.setState({ message: "" });
    };
    const showPass = this.state.showP ? "text" : "password";
    const { passwordRegister, password2 } =
      this.props.state.form &&
      this.props.state.form.LoginRegisterForm !== undefined &&
      this.props.state.form.LoginRegisterForm.values !== undefined &&
      this.props.state.form.LoginRegisterForm.values;

    const renderMatchPassword = () => {
      if (passwordRegister && password2) {
        if (passwordRegister !== password2) {
          return (
            <div style={{ color: "red" }}>
              <b>Password do not match</b>
            </div>
          );
        }
      }
    };

    const renderPasswordError = (val) => {
      if (val)
        return schema.validate(val, { list: true }).map((item) => {
          return (
            <span style={{ color: "red" }} key={item}>
              {" "}
              <b>{item} ,</b>
            </span>
          );
        });
    };

    //************************ */

    return (
      <div className="font-family-Roboto" style={{ borderWidth: "5px" }}>
        <div
          className="card-attached border"
          style={{ maxWidth: "500px", margin: "auto" }}
        >
          {/*  */}

          <div className="disflex-paginator">
            <Image
              className=" border-logo "
              size="small"
              src="/logo.png"
              style={{ marginRight: ".5em" }}
            />
          </div>

          {/*  */}
          <div className="masthead  font-18B textAlign-center pxy-10 color-white">
            {this.state.login &&
              "You have to Login to your account to write or edit review"}
            {this.state.register && "Register"}
          </div>

          <br />
          {/*  */}
          <div>
            <div className=" label pxy-10">
              {this.state.login && (
                <>
                  <Form onSubmit={handleSubmit(this.onSubmit)}>
                    <label>User Id</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>
                    <Field
                      name="userId"
                      type="text"
                      component={TextInput}
                      placeholder="User Id"
                    />
                    <label>Password</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>
                    <Field
                      name="password"
                      type={showPass}
                      //type="password"
                      component={TextInput}
                      placeholder="Password"
                    />
                    <CheckboxInput_2
                      label="Show Password"
                      onChange={this.toggle}
                      checked={this.state.showP}
                    />
                    <br />
                    <br />
                    <div className="flex-center">
                      <Button
                        color="teal"
                        //type="button"
                      >
                        Login
                      </Button>
                      <Button
                        color="blue"
                        type="button"
                        onClick={() => this.props.handleCreateModalClose()}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>{" "}
                  <div className="format-login2  border-db-top ">
                    <span> New to Us?</span>{" "}
                    <span className="tag-cloud" onClick={this.showRegisterForm}>
                      Register
                    </span>
                  </div>
                </>
              )}
              {this.state.register && (
                <>
                  <Form
                    style={{ minWidth: "280px" }}
                    onSubmit={handleSubmit(this.onSubmitRegister)}
                  >
                    <Button
                      color="teal"
                      type="button"
                      onClick={this.props.handleCreateModalClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="orange"
                      type="button"
                      disabled={pristine || submitting}
                      onClick={reset}
                    >
                      Clear Values
                    </Button>
                    <br />
                    <br />
                    <div>
                      (All field marked with{" "}
                      <span style={{ color: "red" }}>
                        <b>*</b>
                      </span>{" "}
                      are required)
                    </div>
                    {/* <Header color="teal" content="User's Details" /> */}
                    <label>User's Name</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>
                    <Field
                      name="uname"
                      type="text"
                      component={TextInput}
                      placeholder="First Name Last Name"
                    />
                    <label>User's Mobile as user ID</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>
                    <Field
                      name="userIdRegister"
                      type="text"
                      component={TextInput}
                      placeholder="Enter Ten Digits Mobile Number"
                    />
                    {this.state.message && (
                      <div className="errorGr">{this.state.message}</div>
                    )}
                    <label>User's Email</label>{" "}
                    {/* <span style={{ color: "red" }}>
                 <b>*</b>
               </span> */}
                    <Field
                      name="uemail"
                      type="email"
                      component={TextInput}
                      placeholder="User's Email"
                    />
                    {/*  */}
                    <label>Password</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>{" "}
                    <Popup trigger={<span>hint?</span>} wide="very">
                      Password Must have Minimum eight and maximum 16
                      characters, at least one uppercase letter, one lowercase
                      letter, one number, one special character and no spaces
                    </Popup>{" "}
                    {renderPasswordError(passwordRegister)}
                    <Field
                      //onBlur=
                      name="passwordRegister"
                      type={showPass}
                      component={TextInput}
                      placeholder="e.g. @Ab12345"
                    />
                    <label>Confirm Password</label>{" "}
                    <span style={{ color: "red" }}>
                      <b>*</b>
                    </span>
                    <Field
                      name="password2"
                      type={showPass}
                      //type="password"
                      component={TextInput}
                      placeholder="Confirm Password"
                    />
                    <CheckboxInput_2
                      label="Show Password"
                      onChange={this.toggle}
                      checked={this.state.showP}
                    />
                    {renderMatchPassword()}
                    <br />
                    <Button
                      color="olive"
                      type="submit"
                      disabled={pristine || submitting}
                    >
                      Signup
                    </Button>
                    <Button
                      color="orange"
                      type="button"
                      disabled={pristine || submitting}
                      onClick={Reset}
                    >
                      Clear Values
                    </Button>
                  </Form>
                  <br />
                </>
              )}
            </div>

            {/* <div className="format-login2 flex-direction-column border-db-top ">
              <div>
                {" "}
                <span> New to us?</span>{" "}
                <span
                className='btnG'
                    onClick={this.handleRegisterModal}
                  >
                    Register
                  
                </span>
              </div>
              <div>
                Forgot Your Password?{" "}
                <Button
                  //floated="right"
                  color="blue"
                  type="button"
                  as={Link}
                  to={`/formpassreset`}
                  onClick={() => this.props.closeModal()}
                >
                  Reset
                </Button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state,
});

export default connect(mapStateToProps, { loginUser, closeModal, openModal })(
  reduxForm({
    form: "LoginRegisterForm", // a unique identifier for this form
    //destroyOnUnmount: false,
    validate,
  })(withRouter(LoginRegisterForm))
);
